import React from 'react';
import { useCurrentTab, useSetTab } from '../context/TabsContext';

type Props = {
  tabKey: number | string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode | string;
  dataTestId?: string;
};
const Tab = ({
  tabKey,
  onClick,
  children,
  className,
  disabled = false,
  dataTestId = 'tab-testId',
}: Props) => {
  const currentTab = useCurrentTab();
  const setTab = useSetTab(tabKey);
  const ref = React.useRef<HTMLDivElement>(null);
  return (
    <div
      ref={ref}
      data-testid={dataTestId}
      onClick={() => {
        if (!disabled) {
          setTab();
          onClick?.();
        }
        if (ref.current) {
          ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }}
      className={`react-tabs__tab ${currentTab === tabKey ? 'react-tabs__tab--selected' : ''
        } ${className || ''}
      `}
      role="tab"
      aria-selected={currentTab === tabKey}
      tabIndex={0}
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      {children}
    </div>
  );
};

export default Tab;
